export const emailRegex =
	"^[a-zA-Z0-9_'\\-\\+]+(\\.[a-zA-Z0-9_'\\-\\+]+)*@[a-zA-Z0-9-.+]+(\\.[a-zA-Z0-9-])*\\.([a-zA-Z]{2,})$";

export const CHECK_SRC_REGEX = /^https?:\/\//;
